
// ==============================================

//        MAP LEAFLET

// ==============================================

document.addEventListener('DOMContentLoaded', function(e) {

  // global var
  var map           = null;
  if (typeof script_data !== 'undefined') {
    var $templateUrl  = script_data.templateUrl;
  }
  var $accessToken  = 'pk.eyJ1IjoidGhpb3ZhbG9uZSIsImEiOiJjamx4aWJlNWcxZTRmM3ZxeGEzbnlhcTV1In0.ModT5idvkryX-FrngVB7fA';
  var $attribution  = 'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, <a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>';
  var $mapStylePath = 'https://api.mapbox.com/styles/v1/mapbox/streets-v10/tiles/256/';
  var $maxZoom      = 18;
  var $minZoom      = 9;
  var $markers_list;

  /*
  *  new_map
  *  This function will render a Leaflet Map onto the selected jQuery element
  *  @param	$el (jQuery element)
  *  @return	n/a
  */
  function new_map( $el ) {

    // create map
    map = L.map( $el[0], { scrollWheelZoom: false } );
    L.tileLayer( $mapStylePath +'{z}/{x}/{y}?access_token={accessToken}', {
      attribution: $attribution,
      accessToken: $accessToken,
      // id         : 'mapbox.streets',
      maxZoom    : $maxZoom,
      minZoom    : $minZoom
    }).addTo( map );
    map.zoomControl.setPosition( 'topright' );

    // add a markers reference
    $markers_list = [];

    // find markers dummy created with WP loop
    var $markers_dummy = $el.find( '.map-marker' );

    // add markers
    $markers_dummy.each( function(){
      add_marker( $(this) );
    });

    center_map();

    // listeners
    map.on( 'zoomstart', function(e) {
      console.log( 'zoom level ' + map.getZoom() );
    });

    return map;
  }

  /*
  *  add_marker
  *  This function will add a marker to the Map
  *  @param	$marker_dummy (jQuery element)
  *  @return	n/a
  */
  function add_marker( $marker_dummy ) {

    var latlng  = L.latLng( $marker_dummy.attr( 'data-lat' ), $marker_dummy.attr( 'data-lng' ) );
    var pinIcon = L.icon({
      iconUrl     : $templateUrl + '/assets/images/svg/marker-pin.svg',
      shadowUrl   : $templateUrl + '/assets/images/marker-pin-shadow.png',
      iconSize    : [44, 59],
      shadowSize  : [59, 74],
      iconAnchor  : [22, 59],
      shadowAnchor: [30, 63],
      popupAnchor : [0, -40]
    });

    // get html content pop up from marker dummy
    // var content = $marker_dummy.html();

    // create pop-up
    // var popup  = L.popup( { className    : 'map-marker-popup'} ).setContent( content );
    // var marker = L.marker( latlng, { icon: pinIcon } ).addTo( map ).bindPopup( popup );

    var marker = L.marker( latlng, { icon: pinIcon } ).addTo( map );

    // add to array
    $markers_list.push( marker );

    // remove markers dummy
    $marker_dummy.remove();
  }


  /*
  *  center_map
  *  This function will center the map, showing all markers attached to this map
  *  @return	n/a
  */
  function center_map() {

    var bounds = L.latLngBounds();

    // loop through all markers and create bounds
    $.each( $markers_list, function( i, marker ){
      bounds.extend( marker.getLatLng() );
    });

    // only 1 marker ?
    if( $markers_list.length == 1 ) {
      // set center of map
      map.setView( bounds.getCenter(), 13);
    } else {
      // fit to bounds
      map.fitBounds( bounds );
    }
  }

  /*
  *  document ready
  *  This function will render each map when the document is ready (page has loaded)
  *  @return	n/a
  */
  if ($('#map').length) map = new_map( $('#map') );

})
